import type { IPayScaleQualification } from 'parent-portal/forms/JobRequestTypes';

export function singleProblem(
    payScaleQualifications: IPayScaleQualification[],
    problemChoiceIds: number[],
): { [key: string]: boolean } {
    const problems = {} as { [key: string]: boolean };
    payScaleQualifications.forEach((qualification: IPayScaleQualification | null) => {
        if (qualification?.qualification_id && problemChoiceIds.includes(qualification.qualification_id)) {
            problems[`${qualification.qualification_id}`] = true;
        }
    });

    return problems;
}

export function booleanProblem(
    payScaleQualifications: IPayScaleQualification[],
    problemChoiceIds: number[],
): { [key: string]: boolean } {
    const problems = {} as { [key: string]: boolean };

    payScaleQualifications.forEach((qualification: IPayScaleQualification) => {
        if (problemChoiceIds.includes(qualification.qualification_id)) {
            problems[`${qualification.qualification_id}`] = true;
        }
    });

    return problems;
}
